<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div class="modal-mask">
        <div class="modal-dialog modal-dialog-slideout modal-lg" >
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal_reps_to_review d-none-">
                <div class="row mb-2 mt-3">
                  <div class="col-8 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ assessment_title }}</div>
                  </div>
                </div>
                <div v-show="loading" class="loading_show">
                  <div class="spinner-border text-danger help-txt"></div>
                  <div v-show="complete_loading" class="assessment_results_loading">Preparing Your Assessment Results</div>
                </div>

                <div class="preview-section text-align-center" v-if="loading == false && question_obj.questions.length == 0" style="background:none">
                  No Questions to display
                </div>

                <div class="preview-section" v-if="loading == false && question_obj.questions.length > 0" >
                  <div class="question-display counter_group-list">
                    <div v-for="(question, qindex) in question_obj.questions" :key="qindex">
                      <div :class="question.error == 1 ? 'error-border' : ''">
                        <div class="question-text">
                          <span class="counter_group-list__counter1">{{ getSerialNumber(qindex) }}</span>
                          {{ question.text }}
                        </div>
                        <div class="question-option">
                          <div class="float-left override-padding text-align-center" :class="questionClass" v-for="(scale_val, index) in question.section_scale" :key="qindex + '-' + index">
                            <div class="radio-button">
                              <input type="radio" :name="'questions-' + qindex"
                              :value="scale_val.value" :checked="scale_val.checked" :key="qindex + '-' + index + '-' + scale_val.value" v-on:click="getAnswersSelected(qindex, index, $event)">
                            </div>
                            <div class="radio-label">
                              <label >{{ scale_val.text }}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="question.error == 1" class="error-text">
                        * Answer Required
                      </div>
                      <div style="clear: both"></div>
                      <div class="border-bottom mt-1 mb-2"></div>


                    </div>
                  </div>
                  <div class="col-12" style="padding-left: 0;" v-if="indexVal == 0 && scaleIds.length == 1">
                    <div class="col-lg-6 padding-lr-5 float-left text-align-left" v-if="this.currentPage > 1">
                      <button
                        v-on:click="goToPage('Previous')"
                        class="btn closeBtn col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 15px; font-weight: bold;"
                        >Previous</button>
                    </div>
                    <div :class="'padding-lr-5 ' + getCompleteAssessmentDivClass" v-if="isShowContinueBtn">
                      <button
                        v-on:click="onSubmit('Completed')"
                        :class="'btn ma-blue-btn ' + getCompleteAssessmentBtnClass"
                        style="height: 30px;border-radius: 15px; margin-top: 2px;font-weight: bold;padding-top: 3px;">Complete Assessment</button>
                    </div>
                    <div class="col-lg-6 padding-lr-5 float-right text-align-right" v-if="question_obj.totalQuestions > this.pageLimit && isPagination">
                      <button v-if="this.currentPage != this.lastPage"
                        v-on:click="goToPage('Next')"
                        class="btn closeBtn col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 15px; font-weight: bold;"
                        >Next</button>
                    </div>
                    <div style="clear: both; margin-bottom: 25px;"></div>

                  </div>

                  <div class="col-12" style="padding-left: 0;" v-if="indexVal == 0 && scaleIds.length > 1">
                    <div class="col-lg-6 padding-lr-5 float-left text-align-left" v-if="this.currentPage > 1">
                      <button
                        v-on:click="goToPage('Previous')"
                        class="btn closeBtn col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 15px; font-weight: bold;"
                        >Previous</button>
                    </div>
                    <div :class="'padding-lr-5 ' + getCompleteAssessmentDivClass" v-if="isShowContinueBtn">
                      <button
                        v-on:click="onSubmit('Inprogress')"
                        class="btn ma-blue-btn col-6"
                        style="height: 30px;border-radius: 15px; margin-top: 2px;font-weight: bold;padding-top: 3px;">Continue</button>
                    </div>
                    <div class="col-lg-6 padding-lr-5 float-right text-align-right" v-if="indexVal == 0 && question_obj.totalQuestions > this.pageLimit && isPagination">
                      <button v-if="this.currentPage != this.lastPage"
                        v-on:click="goToPage('Next')"
                        class="btn closeBtn col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 15px; font-weight: bold;"
                        >Next</button>
                    </div>
                    <div style="clear: both; margin-bottom: 25px;"></div>

                  </div>



                  <div class="col-12 p-0" style="margin-top: 4rem !important;">
                    <div class="col-lg-6 padding-lr-5 float-right text-align-right" style="padding-right: 0;" v-if="indexVal > 0 && (indexVal < parseInt(scaleIds.length - 1)) && isShowContinueBtn">
                      <button
                        v-on:click="onSubmit('Inprogress')"
                        class="btn ma-blue-btn col-6"
                        style="height: 30px;border-radius: 15px; margin-top: 2px;font-weight: bold; padding-top: 1px;">Continue</button>
                    </div>
                    <div class="col-lg-6 padding-lr-5 float-right text-align-right" style="padding-right: 0;" v-if="indexVal > 0 && (indexVal == parseInt(scaleIds.length - 1)) && isShowContinueBtn">
                      <button
                        v-on:click="onSubmit('Completed')"
                        class="btn ma-blue-btn"
                        style="height: 30px;border-radius: 15px; margin-top: 2px;font-weight: bold;">Complete Assessment</button>
                    </div>
                    <div class="col-lg-6 padding-lr-5 float-left text-align-left" v-if="indexVal > 0 && scaleIds.length > 1">
                      <button
                        v-on:click="goToPage('Previous')"
                        class="btn closeBtn col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 15px; font-weight: bold;"
                        >Previous</button>
                    </div>
                    <div class="col-lg-6 padding-lr-5 float-right text-align-right" v-if="indexVal > 0 && question_obj.totalQuestions > this.pageLimit && isPagination">
                      <button v-if="this.currentPage != this.lastPage"
                        v-on:click="goToPage('Next')"
                        class="btn closeBtn col-6 override-padding" style="margin-top: 2px; height: 30px; border-radius: 15px; font-weight: bold;"
                        >Next</button>
                    </div>
                    <div style="clear: both; margin-bottom: 25px;"></div>

                  </div>
                </div>
     
              </div>
            </div>

            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>


<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';


export default {
  props: ['isModalVisible'],
  data() {
    return {
      assessmentId: '',
      assessmentAttemptId: '',
      indexVal: 0,
      sectionIds: [],
      question_obj: {
        questions: [],
        section: [],
        allQuestions: [],
        totalQuestions: 0,
      },
      loading: false,
      complete_loading: false,
      assessment_title: '',
      questionClass: 'custom-col-3',
      currentPage: 1,
      lastPage: 0,
      isShowContinueBtn: false,
      isPagination: false,
      pageLimit: 10,
      scaleIds:[],
    }
  },
  computed: {
    getCompleteAssessmentDivClass() {
      if (this.isPagination) {
        return 'col-lg-6 float-right text-align-right';
      } else {
        return 'col-lg-12 text-align-center';
      }
    },
    getCompleteAssessmentBtnClass() {
      if (this.isPagination) {
        return 'col-12';
      } else {
        return 'col-6';
      }
    }
  },
  methods: {
    hide() {
      this.$emit('closeAssessmentQuestionModal');
    },

            getAnswersSelected: function(qindex, index, event) {
              if(event.returnValue == true) {
                var selected_val = this.question_obj.questions[qindex].section_scale[index].value;
                for(var i=0; i<this.question_obj.questions[qindex].section_scale.length; i++) {
                  this.question_obj.questions[qindex].section_scale[i].checked = false;
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.allQuestions[this.currentPage][qindex].section_scale[i].checked = false;
                  }
                }
                if(this.question_obj.questions[qindex].update == true) {
                  this.question_obj.questions[qindex].modified = true;
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.allQuestions[this.currentPage][qindex].modified = true;
                  }
                }
                else {
                  this.question_obj.questions[qindex].insert = true;
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.allQuestions[this.currentPage][qindex].insert = true;
                  }
                }
                this.question_obj.questions[qindex].section_scale[index].checked = true;
                this.question_obj.questions[qindex].error = 0;
                this.question_obj.questions[qindex].value = selected_val;
                if (this.question_obj.totalQuestions > this.pageLimit) {
                  this.question_obj.allQuestions[this.currentPage][qindex].section_scale[index].checked = true;
                  this.question_obj.allQuestions[this.currentPage][qindex].error = 0;
                  this.question_obj.allQuestions[this.currentPage][qindex].value = selected_val;
                }
              }
            },
            doValidate() {
              var flag = 0;
              for(var i=0; i<this.question_obj.questions.length; i++) {
                if(this.question_obj.questions[i].value == '') {
                  this.question_obj.questions[i].error = 1;
                  flag = 1;
                }    
              }
              return flag;
            },
            onSubmit: function(status) {
              var flag = this.doValidate();
              if(status == 'Completed') {
                this.complete_loading = true;
              }
              if(flag == 0) {
                this.loading = true;
                var scaleId = this.scaleIds[this.indexVal];
                axios('/assessment-section-questions-answers-new/' + scaleId + '/' + this.assessmentAttemptId,
                {
                  method: 'POST',
                  data: {
                    question_obj: this.question_obj,
                    status: status,
                    account_id: this.$store.state.user_accountid,
                  },
                })
                .then(() => {
                  if(status == 'Completed') {
                    this.$emit('closeAssessmentQuestionModal');
                    router.push("/assessment-report-new/" + this.assessmentAttemptId);
                  }
                  else {
                    this.onPrevNext('Next');
                  }
                })
                .catch(() => {

                });

                
              }

            },
            onPrevNext(val) {
              this.currentPage = 1;
              this.lastPage = 1;
              if(val == 'Previous') {
                this.indexVal -= 1;
              }
              else if(val == 'Next') {
                this.indexVal += 1;
              }
              this.getSectionQuestionsLists();
            },
            getScaleLists: function(assessmentId, assessmentAttemptId) {
              this.loading = true;
              this.assessmentId = assessmentId;
              this.assessmentAttemptId = assessmentAttemptId;

              axios.get('/assessment-section-mapping-lists/' + this.assessmentId, {
              })
              .then(resp =>  {
                this.assessment_title = resp.data.assessment.name;
              })
              .catch(function(error) {
                console.log(error);
              });
              axios.get('/assessment-scale-lists-preview/' + this.assessmentId)
                .then((resp) => {

                    this.scaleIds = resp.data;
                    if(this.scaleIds.length > 0) {
                      this.getSectionQuestionsLists();
                    }
                    else {
                      this.loading = false;
                    }
                    
                })
                .catch(error => {

                });
            },
            getSectionQuestionsLists: function() {
              this.loading = true;
              var scaleId = this.scaleIds[this.indexVal];
              if(scaleId) {
                  axios.get('/assessment-section-questions-lists-preview-new/' + scaleId + '/' + this.assessmentId, {
                  params: {
                    attempt_id: this.assessmentAttemptId,
                  }
                  })
                  .then((resp) => {
                      this.loading = false;
                      if(scaleId == 2) {
                        this.questionClass = 'custom-col-2';
                      }
                      else if(scaleId == 3) {
                        this.questionClass = 'custom-col-1';
                      }
                      this.question_obj.totalQuestions = resp.data.questions.length;
                      if (resp.data.questions.length > this.pageLimit) {
                        this.question_obj.questions = resp.data.questions.slice(0, this.pageLimit);
                        this.currentPage = 1;
                        this.lastPage = Math.ceil(resp.data.questions.length/this.pageLimit);
                        for (var m = 1; m <= this.lastPage; m++) {
                          var startVal = 0;
                          var endVal = this.pageLimit;
                          var lastEndVal;
                          if (m == 1) {
                            startVal = 0;
                            endVal = endVal*1;
                          } else {
                            startVal = lastEndVal;
                            endVal = endVal*m;
                          }
                          lastEndVal = endVal;
                          // console.log(startVal + " >> " + endVal)
                          this.question_obj.allQuestions[m] = resp.data.questions.slice(startVal, endVal);
                        }
                        this.isShowContinueBtn = false;
                        this.isPagination = true;
                      } else {
                        this.question_obj.questions = resp.data.questions;  
                        this.isPagination = false;
                        this.isShowContinueBtn = true;
                      }
                      this.question_obj.section = resp.data.section;
                  })
                  .catch(error => {

                  });

              }

            },
            goToPage: function(val) {
              var flag = 1;
              if(val == 'Previous') {
                if (this.currentPage == 1) {
                  this.onPrevNext('Previous');
                } else {
                  this.currentPage -= 1;
                  if (this.currentPage == this.lastPage) {
                    this.isShowContinueBtn = true;
                  } else {
                    this.isShowContinueBtn = false;
                  }
                  if (this.question_obj.totalQuestions > this.pageLimit) {
                    this.question_obj.questions = this.question_obj.allQuestions[this.currentPage];
                  }
                }
              } else {
                if(val == 'Next') {
                  flag = this.doValidate();
                  if(flag == 0) {
                    this.loading = true;
                    var scaleId = this.scaleIds[this.indexVal];
                    axios('/assessment-section-questions-answers-new/' + scaleId + '/' + this.assessmentAttemptId,
                    {
                      method: 'POST',
                      data: {
                        question_obj: this.question_obj,
                        status: status,
                        account_id: this.$store.state.user_accountid,
                      },
                    })
                    .then(() => {
                      for(var i=0; i<this.question_obj.questions.length; i++) {
                        this.question_obj.questions[i].insert = false;
                        if (this.question_obj.totalQuestions > this.pageLimit) {
                          this.question_obj.allQuestions[this.currentPage][i].insert = false;
                        }
                      }                    
                      this.currentPage += 1;  
                      if (this.currentPage == this.lastPage) {
                        this.isShowContinueBtn = true;
                      } else {
                        this.isShowContinueBtn = false;
                      }
                      if (this.question_obj.totalQuestions > this.pageLimit) {
                        this.question_obj.questions = this.question_obj.allQuestions[this.currentPage];
                      }
                      this.loading = false;
                    })
                    .catch(() => {

                    });
                  }
                }
              }
            },
            getSerialNumber(num) {
              var num = num + 1;
              if (this.currentPage == 1) {
                return num + '. ';
              } else {
                return (num + (this.pageLimit * this.currentPage) - this.pageLimit) + '. ';
              }
            }

  },
  components: {

  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;    
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
.custom-col-1 {
  width: 14.11%;
}
.custom-col-2 {
  width: 19.66%; 
}
.custom-col-3 {
  width: 31.11%; 
}
.error-border {
  border: 1px solid #FF0000;
  border-radius: 10px;
  float: left;
  width: 100%;
  padding: 5px;
}
.error-text {
  color: #FF0000;
  font-size: 11px;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: right;
}

</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_assessment_question_new.vue